import React from "react";
import styled from "styled-components";
import {
  borderRadius,
  spacing,
  layer,
  opacity,
  palette,
  Title,
} from "@conserveit/blocks";
import Loading from "../../Loading";

const Overlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${spacing.extraLoose};
  font-size: 19px;
  background: rgba(255, 255, 255, ${opacity.tint});
  z-index: ${layer.fixedContent};
  border-radius: 0 0 ${borderRadius.large} ${borderRadius.large};
`;

const Saving = styled(Title)`
  margin-bottom: ${spacing.default};
  font-size: 18px;
  color: ${palette.neutral7};
`;

export const SavingOverlay = () => (
  <Overlay>
    <Saving>Saving configuration...</Saving>
    <Loading />
  </Overlay>
);
